// Webpack Imports
import * as bootstrap from 'bootstrap';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

// Make Swiper and its modules available globally
window.Swiper = Swiper;
window.SwiperModules = { Navigation, Pagination, Autoplay, EffectFade };

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});
	// Menu
	document.addEventListener('DOMContentLoaded', function () {
	  const submenuParents = document.querySelectorAll('.menu-item-has-children > a');
	
	  submenuParents.forEach(function (parentLink) {
		parentLink.addEventListener('click', function (e) {
		  const isMobile = window.innerWidth < 768;
	
		  if (isMobile) {
			const submenu = parentLink.nextElementSibling;
	
			if (submenu && submenu.classList.contains('sub-menu')) {
			  e.preventDefault(); // prevent navigation
			  submenu.classList.toggle('show');
			}
		  }
		});
	  });
	  
	  // Multi-level dropdown menu support for desktop
	  if (window.innerWidth >= 768) {
		// Prevent Bootstrap dropdown from interfering with CSS hover menus
		const dropdownToggles = document.querySelectorAll('.navbar-nav .dropdown-toggle');
		dropdownToggles.forEach(function(toggle) {
		  // Remove Bootstrap's data-bs-toggle for nested items to allow CSS hover to work
		  if (toggle.closest('.dropdown-menu')) {
			toggle.removeAttribute('data-bs-toggle');
		  }
		});
		
		// Ensure proper hover behavior for nested dropdowns
		const dropdownItems = document.querySelectorAll('.dropdown-menu .dropdown-submenu');
		dropdownItems.forEach(function(item) {
		  let hoverTimeout;
		  
		  // Show submenu on hover
		  item.addEventListener('mouseenter', function() {
			clearTimeout(hoverTimeout);
			const submenu = this.querySelector('.dropdown-menu');
			if (submenu) {
			  submenu.style.display = 'block';
			}
		  });
		  
		  // Hide submenu on mouse leave with small delay
		  item.addEventListener('mouseleave', function() {
			const submenu = this.querySelector('.dropdown-menu');
			if (submenu) {
			  hoverTimeout = setTimeout(function() {
				submenu.style.display = '';
			  }, 200);
			}
		  });
		});
	  }
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});

	// Initialize Hero Swiper
	if (document.querySelector('.hero-swiper')) {
		const heroSwiper = new Swiper('.hero-swiper', {
			modules: [Navigation, Pagination, Autoplay, EffectFade],
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			speed: 1000,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			on: {
				init: function () {
					// Add animation classes when slide changes
					this.slides[this.activeIndex].classList.add('swiper-slide-active');
					// Handle video playback on init
					handleVideoPlayback(this);
				},
				slideChangeTransitionStart: function () {
					// Remove animation classes from all slides
					this.slides.forEach(slide => {
						slide.classList.remove('slide-animation-active');
						// Pause all videos except in active slide to avoid conflicts
						const videos = slide.querySelectorAll('.hero-video');
						videos.forEach(video => {
							// Only pause if not in active slide
							if (slide !== this.slides[this.activeIndex]) {
								video.pause();
								video.currentTime = 0; // Reset video to start
							}
						});
					});
				},
				slideChangeTransitionEnd: function () {
					// Add animation class to active slide
					this.slides[this.activeIndex].classList.add('slide-animation-active');
					// Handle video playback for new active slide
					handleVideoPlayback(this);
				}
			}
		});
		
		// Function to handle video playback
		function handleVideoPlayback(swiper) {
			const activeSlide = swiper.slides[swiper.activeIndex];
			const video = activeSlide.querySelector('.hero-video');
			
			if (video) {
				// Wait a bit to ensure previous videos are paused
				setTimeout(() => {
					// Check if video is already playing
					if (!video.paused) return;
					
					// Reset video and play
					video.currentTime = 0;
					const playPromise = video.play();
					
					if (playPromise !== undefined) {
						playPromise
							.then(() => {
								// Video started successfully
								console.log('Hero video playing');
							})
							.catch(error => {
								// Auto-play was prevented
								console.log('Video autoplay prevented:', error.message);
								// Don't hide video, just show with poster
							});
					}
				}, 100); // Small delay to avoid play/pause conflicts
				
				// Pause autoplay when video is playing (since videos loop)
				swiper.autoplay.stop();
			} else {
				// No video, ensure autoplay is running
				swiper.autoplay.start();
			}
		}
		
		// Optimize video loading based on connection
		function optimizeVideoLoading() {
			if ('connection' in navigator) {
				const connection = navigator.connection;
				const videos = document.querySelectorAll('.hero-video');
				
				videos.forEach(video => {
					// Disable autoplay on slow connections
					if (connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g') {
						video.removeAttribute('autoplay');
						video.preload = 'metadata';
					}
					
					// Add loading attribute for better performance
					video.loading = 'lazy';
				});
			}
		}
		
		// Call optimization function
		optimizeVideoLoading();
	}

	// Initialize Small Featured Swiper
	if (document.querySelector('.small-featured-swiper')) {
		const smallFeaturedSwipers = document.querySelectorAll('.small-featured-swiper');
		
		smallFeaturedSwipers.forEach((swiperElement) => {
			const nextButton = swiperElement.parentElement.querySelector('.small-featured-next');
			const prevButton = swiperElement.parentElement.querySelector('.small-featured-prev');
			
			const swiper = new Swiper(swiperElement, {
				modules: [Navigation],
				slidesPerView: 1.2,
				spaceBetween: 15,
				centeredSlides: false,
				watchSlidesProgress: true,
				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
				},
				breakpoints: {
					576: {
						slidesPerView: 2.2,
						spaceBetween: 20,
					},
					768: {
						slidesPerView: 3.2,
						spaceBetween: 24,
					},
					992: {
						slidesPerView: 4.2,
						spaceBetween: 24,
					},
					1200: {
						slidesPerView: 5.2,
						spaceBetween: 24,
					}
				},
				on: {
					init: function() {
						handleCardVideos(this);
						// Hide prev button on init if at beginning
						if (this.isBeginning) {
							prevButton.classList.remove('swiper-button-visible');
						}
					},
					slideChange: function() {
						handleCardVideos(this);
						// Show/hide prev button based on position
						if (this.isBeginning) {
							prevButton.classList.remove('swiper-button-visible');
						} else {
							prevButton.classList.add('swiper-button-visible');
						}
					}
				}
			});
		});
		
		// Handle video autoplay in cards
		function handleCardVideos(swiper) {
			const slides = swiper.slides;
			
			slides.forEach((slide, index) => {
				const video = slide.querySelector('.card-video');
				if (video) {
					// Check if slide is visible
					const isVisible = index >= swiper.activeIndex && index < swiper.activeIndex + swiper.params.slidesPerView;
					
					if (isVisible && video.paused) {
						// Play video only if not already playing
						video.play().catch(error => {
							console.log('Card video autoplay failed:', error.message);
						});
					} else if (!isVisible && !video.paused) {
						// Pause video only if playing
						video.pause();
					}
				}
			});
		}
		
		// Intersection Observer for video performance
		const cardVideos = document.querySelectorAll('.card-video');
		if (cardVideos.length > 0 && 'IntersectionObserver' in window) {
			const videoObserver = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					const video = entry.target;
					if (entry.isIntersecting && video.paused) {
						video.play().catch(error => {
							console.log('Card video autoplay failed:', error.message);
						});
					} else if (!entry.isIntersecting && !video.paused) {
						video.pause();
					}
				});
			}, {
				threshold: 0.25
			});
			
			cardVideos.forEach(video => {
				videoObserver.observe(video);
			});
		}
	}

	// Initialize Latest Spots Swiper
	if (document.querySelector('.latest-spots-swiper')) {
		const latestSpotsSwiper = new Swiper('.latest-spots-swiper', {
			modules: [Navigation, Pagination],
			slidesPerView: 1,
			spaceBetween: 15,
			navigation: {
				nextEl: '.latest-spots-swiper .swiper-button-next',
				prevEl: '.latest-spots-swiper .swiper-button-prev',
			},
			pagination: {
				el: '.latest-spots-swiper .swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				576: {
					slidesPerView: 2,
					spaceBetween: 20,
					slidesPerGroup: 2,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 24,
					slidesPerGroup: 2,
				},
				992: {
					slidesPerView: 3,
					spaceBetween: 24,
					slidesPerGroup: 3,
				}
			}
		});
	}

	// Header scroll effect for homepage, category pages, and single posts with hero
	if (document.body.classList.contains('home') || document.body.classList.contains('category') || document.body.classList.contains('page') || document.body.classList.contains('single-post')) {
		const header = document.querySelector('#header.hero-header');
		if (header) {
			let ticking = false;

			// Helper function to check if on mobile
			function isMobile() {
				return window.innerWidth < 768;
			}

			function updateHeader() {
				const scrolled = window.pageYOffset;
				const scrollThreshold = 100;
				const logo = header.querySelector('.navbar-brand-logo');
				const search = header.querySelector('.navbar-search');
				const langs = header.querySelector('.navbar-lang');
				const mobile = isMobile();

				if (scrolled > scrollThreshold) {
					header.classList.add('scrolled');
					// Switch to color logo when scrolled
					if (logo && logo.src.includes('logo.svg')) {
						logo.src = logo.src.replace('logo.svg', 'logo-color.svg');
						// Only swap icon images on desktop (mobile uses CSS filter)
						if (!mobile) {
							search.src = search.src.replace('search.png', 'search-o.png');
							langs.src = langs.src.replace('lang.png', 'lang-o.png');
						}
					}
				} else {
					header.classList.remove('scrolled');
					// Switch back to white logo when at top (only on homepage)
					if (
					  logo &&
					  logo.src.includes('logo-color.svg') &&
					  (
						document.body.classList.contains('home') ||
						document.body.classList.contains('single') ||
						document.body.classList.contains('archive')
					  )
					) {
						logo.src = logo.src.replace('logo-color.svg', 'logo.svg');
						// Only swap icon images on desktop (mobile uses CSS filter)
						if (!mobile) {
							search.src = search.src.replace('search-o.png', 'search.png');
							langs.src = langs.src.replace('lang-o.png', 'lang.png');
						}
					}
				}

				ticking = false;
			}
			function requestTick() {
				if (!ticking) {
					requestAnimationFrame(updateHeader);
					ticking = true;
				}
			}
			
			window.addEventListener('scroll', requestTick, { passive: true });
		}
	}
	// Handle prefecture selection from map (optional - navigation is now handled in the map component)
	document.addEventListener('prefectureSelected', function(event) {
		const prefecture = event.detail;
		console.log('Prefecture selected:', prefecture);
		// Custom handling can be added here if needed
	});
})();
